export enum BannerKey {
    BUY_POLICY = 'BUY_POLICY', // step banner
    ACCIDENTS_HAPPEN = 'ACCIDENTS_HAPPEN', // step banner
    DRIVER_SOS = 'DRIVER_SOS', // offers list banner
    DRIVER_SOS_DETAILS = 'DRIVER_SOS_DETAILS', // payment banner
}
